var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelephone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99958 16.92V19.92C1.99845 20.1985 2.0555 20.4741 2.16707 20.7293C2.27864 20.9845 2.44228 21.2136 2.6475 21.4018C2.85273 21.5901 3.09501 21.7335 3.35883 21.8227C3.62266 21.9119 3.90221 21.945 4.17958 21.92C7.25675 21.5856 10.2126 20.5341 12.8096 18.85C15.2258 17.3146 17.2742 15.2661 18.8096 12.85C20.4996 10.2412 21.5513 7.27097 21.8796 4.17997C21.9046 3.90344 21.8717 3.62473 21.7831 3.3616C21.6945 3.09846 21.552 2.85666 21.3648 2.6516C21.1776 2.44653 20.9498 2.28268 20.6958 2.1705C20.4418 2.05831 20.1672 2.00024 19.8896 1.99997H16.8896C16.4043 1.9952 15.9338 2.16705 15.5658 2.48351C15.1978 2.79996 14.9575 3.23942 14.8896 3.71997C14.763 4.68004 14.5281 5.6227 14.1896 6.52997C14.055 6.8879 14.0259 7.27689 14.1057 7.65085C14.1854 8.02482 14.3707 8.36809 14.6396 8.63997L15.9096 9.90997C14.486 12.4135 12.4131 14.4864 9.90958 15.91L8.63958 14.64C8.36769 14.3711 8.02443 14.1858 7.65046 14.1061C7.2765 14.0263 6.8875 14.0554 6.52958 14.19C5.62231 14.5285 4.67965 14.7634 3.71958 14.89C3.23381 14.9585 2.79018 15.2032 2.47305 15.5775C2.15592 15.9518 1.98741 16.4295 1.99958 16.92Z",
    stroke: "url(#paint0_linear_379_2822)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_379_2822",
    x1: 11.9387,
    y1: -7.90866,
    x2: 11.9387,
    y2: 26.2892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00902,
    stopColor: "#F6CD66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0391861,
    stopColor: "#DCAE4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0707524,
    stopColor: "#C8963B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1039,
    stopColor: "#B9852D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1397,
    stopColor: "#B17A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1829,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3046,
    stopColor: "#CE9E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#E8BF61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4902,
    stopColor: "#F2CB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5439,
    stopColor: "#ECC466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    stopColor: "#DDB155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7132,
    stopColor: "#C3923A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8178,
    stopColor: "#B27C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8661,
    stopColor: "#BF8B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9189,
    stopColor: "#D3A446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9745,
    stopColor: "#F0C660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.dbeed80dc92ef599ffce56f0bed59975.svg";
export { ForwardRef as ReactComponent };